module.exports = __webpack_public_path__ + "static/sweatcoin-eb6bfc7dbcfacde207d1f62716d6a513.png";